import { render, staticRenderFns } from "./d-badge-unlocked-activity.vue?vue&type=template&id=504c39cc&scoped=true&"
import script from "./d-badge-unlocked-activity.vue?vue&type=script&lang=js&"
export * from "./d-badge-unlocked-activity.vue?vue&type=script&lang=js&"
import style0 from "./d-badge-unlocked-activity.vue?vue&type=style&index=0&id=504c39cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c39cc",
  null
  
)

export default component.exports